export const COMPETITORS = [
  { name: "ExpressVPN", price: "$12.95/mo", devices: "5", logs: "Audited no-logs", gaming: "No gaming routes" },
  { name: "NordVPN",    price: "$12.99/mo", devices: "6", logs: "Audited no-logs", gaming: "Standard servers" },
  { name: "Surfshark",  price: "$12.95/mo", devices: "Unlimited", logs: "No-logs", gaming: "No gaming routes" },
  { name: "ProtonVPN",  price: "$9.99/mo", devices: "10", logs: "No-logs", gaming: "Privacy-focused" },
  { name: "CyberGhost", price: "$12.99/mo", devices: "7", logs: "No-logs", gaming: "Streaming servers only" },
  { name: "PIA",        price: "$11.99/mo", devices: "Unlimited", logs: "No-logs", gaming: "No gaming routes" },
];

export const FEATURES = [
  {
    feature: "Unlimited devices on entry plans",
    sacvpn: "✅ Yes (Personal / Gaming)",
    express: "❌ 5 devices",
    nord: "❌ 6 devices",
    surfshark: "✅ Unlimited",
    proton: "❌ 10 devices",
    cyberghost: "❌ 7 devices",
    pia: "✅ Unlimited",
  },
  {
    feature: "One-click QR setup",
    sacvpn: "✅ QR + Email setup",
    express: "❌ Manual configs only",
    nord: "❌ Manual configs only",
    surfshark: "❌ Manual configs only",
    proton: "❌ Manual configs only",
    cyberghost: "❌ Manual configs only",
    pia: "❌ Manual configs only",
  },
  {
    feature: "Transparent business pricing",
    sacvpn: "✅ $100 (10), $450 (50), $800 (100)",
    express: "Enterprise only",
    nord: "Enterprise only",
    surfshark: "Enterprise only",
    proton: "Limited business plans",
    cyberghost: "❌ None",
    pia: "❌ None",
  },
  {
    feature: "WireGuard-only protocol",
    sacvpn: "✅ Yes (faster & modern)",
    express: "❌ Uses Lightway/OpenVPN",
    nord: "✅ WireGuard (NordLynx)",
    surfshark: "✅ WireGuard available",
    proton: "✅ WireGuard available",
    cyberghost: "✅ WireGuard available",
    pia: "✅ WireGuard available",
  },
  {
    feature: "No-logs policy",
    sacvpn: "✅ No activity logs (not audited)",
    express: "✅ No-logs (audited)",
    nord: "✅ No-logs (audited)",
    surfshark: "✅ No-logs",
    proton: "✅ No-logs",
    cyberghost: "✅ No-logs",
    pia: "✅ No-logs",
  },
  {
    feature: "Starting price under $10",
    sacvpn: "✅ $9.99",
    express: "❌ $12.95",
    nord: "❌ $12.99",
    surfshark: "❌ $12.95",
    proton: "❌ $9.99",
    cyberghost: "❌ $12.99",
    pia: "❌ $11.99",
  },
];
